export const CONTACT_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbwxg8qdxEzQlK9QKUBoYF3bCcwD-uXBrVXsFr4RaeW6mHRUmrsT34is3WEaWPuDpNYX/exec";

export type ContactPrefill = {
  service?: string;
  category?: string;
  serviceId?: string;
  query?: string;
  message?: string;
};

export type ContactFormPayload = {
  name: string;
  email: string;
  phone: string;
  company: string;
  service: string;
  query: string;
  message: string;
  source?: string;
};

/** Build a short one-line enquiry message. */
export function buildEnquiryMessage(topic?: string) {
  const subject = topic?.trim() || "your services";
  return `Hello DevDotCom team, I would like to enquire about ${subject}.`;
}

/** Submit contact form to Google Apps Script → Sheets. */
export async function submitContactForm(
  payload: ContactFormPayload
): Promise<void> {
  const body = {
    ...payload,
    timestamp: new Date().toISOString(),
    source: payload.source || "website",
  };

  // text/plain avoids a CORS preflight; Apps Script doPost can JSON.parse(e.postData.contents)
  const res = await fetch(CONTACT_SCRIPT_URL, {
    method: "POST",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify(body),
    redirect: "follow",
  });

  // Apps Script often returns 200 even with opaque redirects; treat network errors as failure
  if (!res.ok && res.type !== "opaque") {
    throw new Error(`Contact submit failed (${res.status})`);
  }
}
